/**
 * Notification Display Component
 * Renders notifications using Shadcn Toast
 */

import React from 'react';

import { useToast } from '@/hooks/use-toast';

import { useNotification } from '../../hooks/useNotification';

/**
 * Component that bridges our custom notification hook with Shadcn Toast
 */
export const NotificationDisplay: React.FC = () => {
  const { toast } = useToast();
  const { notifications, dismiss } = useNotification();

  React.useEffect(() => {
    notifications.forEach((notification: any) => {
      toast({
        title:
          notification.title ||
          (notification.type === 'error' ? 'Error' : 'Notification'),
        description: notification.message,
        variant: notification.type === 'error' ? 'destructive' : 'default',
        duration: notification.duration ?? 3000,
      });
      // Dismiss from our internal state immediately since Shadcn handles its own display
      dismiss(notification.id);
    });
  }, [notifications, toast, dismiss]);

  return null;
};

export default NotificationDisplay;
